import React, { Fragment, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router';
import axios from './axios';
import { useAuth } from '../context/AuthProvider';

interface IAxiosInterceptor {
  children: ReactNode;
}

export const AxiosInterceptor: React.FC<IAxiosInterceptor> = ({
  children,
}): JSX.Element => {
  const { clearCurrentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          if (window.location.pathname !== '/login') {
            clearCurrentUser();
          }
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);

  return <Fragment>{children}</Fragment>;
};
